module.exports = __webpack_public_path__ + "static/media/Group 3983@2x.d2c71619.png";